module.exports = __webpack_public_path__ + "img/salary-settings.2a0f9b3a.svg";